export default {
  container: {
    display: ({ showMenu }) => (showMenu ? 'inherit' : 'none'),
    width: '100vw',
    background: 'rgba(0, 0, 0, 0.4)'
  }
}
